import { WelcomeBonusCalculator } from './WelcomeBonusCalculator';

export default WelcomeBonusCalculator;
